import React, { useEffect } from "react";
import { useTheme, Card, Typography, Link, Box } from "@mui/material";
import lotImage from "../../assets/images/lot.svg";
import backImage from "../../assets/images/arrow-back.svg";
import snImage from "../../assets/images/sn.svg";
import manufacturerImage from "../../assets/images/manufacturer.svg";
import { Helmet } from "react-helmet";
import { Stack } from "@mui/material";
const useStyles = () => {
  const theme = useTheme();
  return {
    linkStyle: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "17.5px",
      letterSpacing: "0.25px",
      color: theme.palette.text.linkColor,
    },
    backBtn: {
      cursor: "pointer",
      width: "65px",
      margin: "0 20px 30px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    backBtnText: {
      fontSize: "14px",
      lineHeight: "24px",
      letterSpacing: "1px",
      color: theme.textColour.primaryColor,
      fontWeight: 600,
    },
    container: {
      margin: "40px auto 0",
      maxWidth: { xs: "auto", sm: "900px" },
      width: { xs: "100%" },
    },
    aboutCard: {
      padding: "0px 40px",
      margin: "0 20px",
      borderRadius: "8px",
    },
    infoIcon: {
      color: theme.palette.primary.light,
      backgroundColor: theme.palette.background.primary,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "30px",
      width: "30px",
      padding: "7.5px",
      borderRadius: "50%",
    },
    aboutCardTitle: {
      color: theme.palette.text.textSecondaryColor,
      fontWeight: 400,
      fontSize: "24px",
    },
    subTitleText: {
      fontSize: "14px",
      color: theme.palette.text.textSixthColor,
      paddingBottom: "8px",
      fontWeight: 600,
      lineHeight: "17.5px",
      letterSpacing: "0.25px",
    },
    normalText: {
      color: theme.palette.text.textFifthColor,
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "17.5px",
      letterSpacing: "0.25px",
    },
    userGuideIcon: {
      height: "40px",
      aspectRatio: 1,
    },
  };
};
function AboutPage() {
  const styles = useStyles();
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <>
      <Helmet>
        <title>About</title>
      </Helmet>
      <Box sx={styles.container}>
        <Box
          sx={styles.backBtn}
          onClick={() => {
            window.history.back();
          }}
        >
          <img src={backImage} alt="back" height="20px" />
          <Typography sx={styles.backBtnText}>Back</Typography>
        </Box>
        <Card sx={styles.aboutCard}>
          <Stack spacing={3}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="left"
              padding="24px 16px"
            >
              <Typography sx={styles.aboutCardTitle}>
                About AIMS Assessment
              </Typography>
            </Stack>
            <Stack
              justifyContent="space-between"
              direction={{ xs: "column", sm: "row" }}
              padding="10px"
              spacing={{ xs: 2 }}
            >
              <Box>
                <img src={lotImage} alt="LOT" />
                <Typography sx={styles.subTitleText}>Version Number</Typography>
                <Typography sx={styles.normalText}>
                  {process.env.REACT_APP_VERSION ?? "XXXX"}
                </Typography>
              </Box>
              <Box>
                <img src={snImage} alt="LOT" />
                <Typography sx={styles.subTitleText}>Serial Number</Typography>
                <Typography sx={styles.normalText}>
                  {process.env.REACT_APP_VERSION && userId
                    ? `${process.env.REACT_APP_VERSION}.${userId}`
                    : "XXXX"}
                </Typography>
              </Box>
              <Stack spacing={3}>
                <Box>
                  <img src={manufacturerImage} alt="LOT" />
                  <Typography sx={styles.subTitleText}>Manufacturer</Typography>
                  <Typography sx={styles.normalText}>
                    Amalgam Rx, Inc
                    <br />
                    1007 N. Orange St.
                    <br />
                    Suite 400
                    <br />
                    Wilmington, DE 19801
                    <br />
                    United States
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={styles.subTitleText}>
                    Date of Manufacture:
                  </Typography>
                  <Typography sx={styles.normalText}>
                    {process.env.REACT_APP_DATE ?? "XXX-XX-XX"}
                  </Typography>
                </Box>
              </Stack>
            </Stack>
            <Box>
              <Typography sx={styles.subTitleText}>Intended Use</Typography>
              <Typography sx={styles.normalText}>
                The Abnormal Involuntary Movement Scale (AIMS) application is a
                clinical tool intended for use by healthcare professionals to
                assess and monitor the severity of dyskinesias, particularly
                tardive dyskinesia (TD), in patients taking neuroleptic
                (antipsychotic) medications. The AIMS Application is based on a
                clinical tool, published in the 1976 ECDEU Assessment Manual for
                Psychopharmacology, and its use is considered standard of care
                for assessment of TD. This web-based application is for
                qualified US health care professionals who have been designated,
                at their practice, to complete an AIMS assessment for patients.
                It is not intended to be used by patients or caregivers or as a
                substitute for a visit or consultation with a Healthcare
                Professional.
              </Typography>
            </Box>
            <Box>
              <Typography sx={styles.subTitleText}>
                Supported Browsers
              </Typography>
              <Typography sx={styles.normalText}>
                AIMS Assessment is supported with the latest version(s) of
                Chrome, Safari, Edge, and Firefox.
              </Typography>
            </Box>
            <Box>
              <Typography sx={styles.subTitleText}>
                Sponsored by Teva Neuroscience, Inc.
              </Typography>
            </Box>
            <Box paddingBottom="16px">
              <Typography sx={styles.subTitleText}>
                Technical Support
              </Typography>
              <Typography>
                <Link
                  target="_blank"
                  sx={styles.linkStyle}
                  underline="none"
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=eAims-Assessment@amalgamrx.com"
                >
                  eAims-Assessment@amalgamrx.com
                </Link>
              </Typography>
            </Box>
          </Stack>
        </Card>
      </Box>
    </>
  );
}
export default AboutPage;
